import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"check\"><title>check</title><g id=\"check_Layer_8\" data-name=\"Layer 8\"><path d=\"M7.75,16.3857,3.2178,11.8535a.5.5,0,0,1,.707-.707L7.75,14.9717l9.3965-9.3965a.5.5,0,1,1,.707.707Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/check.svg
// module id = LI6s
// module chunks = 4